import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '@/store/authStore';

export default function AdminRoute() {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!['admin', 'super_admin'].includes(user?.role)) return <Navigate to="/game" replace />;

  return <Outlet />;
}
